<script lang="ts">
	import BookCard from '@components/global/BookCard.svelte';
	import type { BookData } from '@lib/types';
	import { twMerge } from 'tailwind-merge';

	export let books: BookData[] = [];

	let className = '',
		listView: 'grid' | 'list' = 'grid';

	export { className as class, listView };
</script>

<div
	class={twMerge('grid gap-3 pre-sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5', className)}
	class:grid-cols-2={listView === 'grid'}
	class:grid-cols-1={listView === 'list'}
>
	{#each books as book}
		<BookCard {book} viewDirection={listView === 'list' ? 'horizontal' : 'vertical'} />
	{/each}
</div>
